import { useEffect, useRef, useState } from "react";

export default function MaxLicenseSetterComponent({ currentValue, onChange }) {
  const [value, setValue] = useState(currentValue);

  const maxLimit = 10000;
  const minLimit = -1;

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const changeValue = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };

  const startChanging = (direction) => {
    // Первое изменение сразу
    const newValue = Math.max(minLimit, Math.min(value + direction, maxLimit));

    changeValue(newValue);

    // Затем небольшая задержка перед повторением
    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        setValue((currentValue) => {
          const nextValue = Math.max(minLimit, Math.min(currentValue + direction, maxLimit));

          onChange(nextValue);

          return nextValue;
        });
      }, 100);
    }, 100);
  };

  const stopChanging = () => {
    clearTimeout(timeoutRef.current);
    clearInterval(intervalRef.current);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, []);

  const handleChange = (event) => {
    const newValue = Number(event.target.value);

    if (newValue >= minLimit && newValue <= maxLimit) {
      changeValue(newValue);
    }
  };

  return (
    <div className="license-limit-setter flex-row">
      <input type="number" min={minLimit} max={maxLimit} className="license-limit-setter__content" value={value} onChange={handleChange} />

      <div className="flex-column">
        <button
          type="button"
          className="license-limit-setter__button button flex-row"
          onMouseDown={() => startChanging(1)}
          onMouseUp={stopChanging}
          onMouseLeave={stopChanging}
          disabled={value >= maxLimit}
        >
          <span hidden={value === maxLimit}>▲</span>
          <span hidden={value < maxLimit}>△</span>
        </button>

        <button
          type="button"
          className="license-limit-setter__button button flex-row"
          onMouseDown={() => startChanging(-1)}
          onMouseUp={stopChanging}
          onMouseLeave={stopChanging}
          disabled={value <= minLimit}
        >
          <span hidden={value === minLimit}>▼</span>
          <span hidden={value > minLimit}>▽</span>
        </button>
      </div>
    </div>
  );
}
